import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles({
  modal: {
    // width: "400px",
    minHeight: "700px",
    "& .modal-header": {
      padding: "24px 24px 0px",
      flexDirection: "column",
      paddingBottom: "8px",
      alignItems: "flex-start",
      // borderBottom: `1px solid ${colors.lightGrey}`,
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      },
      "& #uc-header-title": {
        display: "flex",
      }
    },
    "& .modal-body": {
      padding: "12px 24px 0"
    },
    "& .modal-footer": {
      padding: "24px 24px"
    },
    "& .modal-footer>*": {
      margin: "0px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  headerTitle: {
    marginTop: "8px",
    "& h3": {
      fontSize: "18px",
      color: colors.lightBlack,
      fontWeight: "600",
      lineHeight: "28px",
      margin: "0px"
    },
    "& p": {
      fontSize: "14px",
      color: colors.turquoiseBlue,
      fontWeight: "400",
      lineHeight: "20px",
      margin: "0px"
    },
  },
  modalContent: {
    marginTop: "8px",
    display: "flex",
    flexDirection: "column",
    "& hr": {
      border: "1px solid " + colors.lightGrey,
      opacity: "1",
      margin: "0px"
    }
  },
  flightInfoContainer: {
    display: "flex",
    marginTop: "24px"
  },
  flightInfoBox: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "12px",
    width: "100%",
    "& p": {
      fontSize: "14px",
      color: colors.mediumGrey,
      fontWeight: "500",
      lineHeight: "20px",
      margin: "0px"
    }
  },
  flightInfo: {
    display: "flex",
    gap: "5px",
    "& p": {
      fontSize: "12px",
      color: colors.inactiveGrey,
      fontWeight: "500",
      lineHeight: "18px",
      margin: "0px"
    }
  },
  flightInfoDot: {
    height: "4px",
    width: "4px",
    borderRadius: "50%",
    backgroundColor: colors.inactiveGrey,
    display: "inline-block",
    margin: "auto 0px"
  },
  recordLocatorContainer: {
    display: "flex",
    flexDirection: "column",
    margin: "16px 0px",
    padding: "12px",
    borderRadius: "4px",
    backgroundColor: colors.veryLightGrey,
    "& p": {
      fontSize: "12px",
      color: colors.inactiveGrey,
      fontWeight: "500",
      lineHeight: "18px",
      margin: "0px"
    }
  },
  recordLocatorBox: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    "& p": {
      fontSize: "16px",
      color: colors.mediumGrey,
      fontWeight: "600",
      lineHeight: "24px",
      margin: "0px"
    }
  },
  manageBtn: {
    display: "flex",
    gap: "8px",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    "& a": {
      textDecoration: "none",
      color: "inherit"
    }
  },
  flightsDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px"
  },
  flightWrapper: {
    display: "flex",
    justifyContent: "space-between",
    position: "relative",
    padding: "10px 0px"
  },
  flightName: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    "& h1": {
      fontSize: "20px",
      color: colors.lightBlack,
      fontWeight: "700",
      lineHeight: "30px",
      marginBottom: "2px"
    },
    "& p": {
      fontSize: "14px",
      color: colors.mediumGrey,
      fontWeight: "400",
      lineHeight: "20px",
      margin: "0px"
    },
  },
  flightTime: {
    display: "flex",
    flexDirection: "column",
    "& p": {
      fontSize: "18px",
      color: colors.lightBlack,
      fontWeight: "500",
      lineHeight: "28px",
      marginBottom: "4px"
    },
  },
  flightBadgeScheduled: {
    backgroundColor: colors.veryLightGrey,
    borderRadius: "16px",
    padding: "2px 8px",
    "& span" : {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      fontSize: "12px",
      color: colors.grey,
      fontWeight: "500",
      lineHeight: "18px",
      margin: "0px"
    }
  },
  flightBadgeDelayed: {
    extend: "flightBadgeScheduled",
    backgroundColor: colors.pinkLightRed,
    "& span" : {
      color: colors.darkerRed,
    }
  },
  flightBadgeOntime: {
    extend: "flightBadgeScheduled",
    backgroundColor: colors.veryLightGreen,
    "& span" : {
      color: colors.lightgreen,
    }
  },
  flightTimeExtra: {
    position: "absolute",
    top: "2px",
    right: "-6px",
    fontSize: "12px",
    color: colors.lightBlack,
    fontWeight: "400",
    lineHeight: "18px",
    margin: "0px"
  },
  dividerTime: {
    whiteSpace: "nowrap",
    fontSize: "12px",
      color: colors.paleGrey,
      fontWeight: "400",
      lineHeight: "18px",
      margin: "0px"
  },
  cancelBtn: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    marginTop: "8px"
  }
});

export default styles;
